
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>
    <span>Please provide the following information for Smart Circle to use in preparing your Distribution and Services Agreement and Statement(s) of Work.</span>
    <!-- general form elements disabled -->
    <div class="row">
      <div class="col-sm-4">
        <label class="col-form-label col-md-12" for="US_or_CA_US">Country <code>*</code></label>
        <div class="col-md-12">
          <div class="form-check">
            <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA_US" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
            <label for="US_or_CA_US" class="form-check-label">US</label>
          </div>
          <div class="form-check">
            <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
            <label for="US_or_CA_CA" class="form-check-label">Canada</label>
          </div>
          <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback d-block">Country is required</div>
        </div>
      </div>

    </div>


    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">Legal Information</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">


        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">

              <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Full Legal Company Name <code>*</code></label>
              <input type="text" formControlName="Full_Legal_Company_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Full_Legal_Company_Name"
                     [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && !f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                     appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
               'text-danger': f.Full_Legal_Company_Name.errors?.maxlength,
               'text-muted': !f.Full_Legal_Company_Name.errors?.maxlength
             }">

                {{ icdForm.get('Full_Legal_Company_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Full_Legal_Company_Name }}

              </div>
              <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                <div *ngIf="f.Full_Legal_Company_Name.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Full_Legal_Company_Name }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
              <input type="text" formControlName="Tax_ID" class="form-control" [attr.maxlength]="fieldMaxLengths.Tax_ID"
                     appFeinMask [feinCountry]="selectedCountry"
                     [ngClass]="{'is-valid': f.Tax_ID.valid, 'is-invalid' : submitted && !f.Tax_ID.valid}" placeholder="Enter  F.E.I.N. # (Tax ID)/Business" />
              <div class="text-right small mt-1"
                   [ngClass]="{
               'text-danger': f.Tax_ID.errors?.maxlength,
               'text-muted': !f.Tax_ID.errors?.maxlength
             }">

                {{ icdForm.get('Tax_ID')?.value?.length || 0 }}/{{ fieldMaxLengths.Tax_ID }}

              </div>
              <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                <div *ngIf="f.Tax_ID.errors.required">F.E.I.N. # (Tax ID)/Business #  is required</div>
                <div *ngIf="f.Tax_ID.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Tax_ID }} characters allowed
                </div>
              </div>


            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="State_of_Incorporation">State of Incorporation <code>*</code></label>
              <ng-select [searchable]="true" formControlName="State_of_Incorporation" [ngClass]="{'is-valid': f.State_of_Incorporation.valid, 'is-invalid' : submitted && !f.State_of_Incorporation.valid}">
                <ng-option *ngFor="let o of ddlUSStates"
                           [value]="o.value">
                  {{ o.name }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && f.State_of_Incorporation.errors" class="invalid-feedback d-block">
                <div *ngIf="f.State_of_Incorporation.errors.required">State of Incorporation is required</div>
              </div>

            </div>
          </div>


          <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="Provinence_of_Incorporation">Province of Incorporation <code>*</code></label>
              <ng-select [searchable]="true" formControlName="Provinence_of_Incorporation" [ngClass]="{'is-valid': f.Provinence_of_Incorporation.valid, 'is-invalid' : submitted && !f.Provinence_of_Incorporation.valid}">
                <ng-option *ngFor="let o of ddlCAProvinence"
                           [value]="o.value">
                  {{ o.name }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && f.Provinence_of_Incorporation.errors" class="invalid-feedback d-block">
                <div *ngIf="f.Provinence_of_Incorporation.errors.required">Province Incorporation is required</div>
              </div>

            </div>
          </div>




        </div>


      </div>

    </div>



    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">Company Information (For Official Notices)</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">


          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Address1">Business Address 1 <code>*</code></label>
              <input type="text" formControlName="Company_Address1" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address1"
                     [ngClass]="{'is-valid': f.Company_Address1.valid, 'is-invalid' : submitted && !f.Company_Address1.valid}" placeholder="Enter Address 1"
                     appAiHint="Company Address 1" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
               'text-danger': f.Company_Address1.errors?.maxlength,
               'text-muted': !f.Company_Address1.errors?.maxlength
             }">

                {{ icdForm.get('Company_Address1')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address1 }}

              </div>
              <div *ngIf="submitted && f.Company_Address1.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Address1.errors.required">Address 1  is required</div>
                <div *ngIf="f.Company_Address1.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Company_Address1 }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Address2">Address 2(e.g. Suite 100)</label>
              <input type="text" formControlName="Company_Address2" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address2"
                     placeholder="Enter Address 2 "
                     appAiHint="Company Address 2" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
               'text-danger': f.Company_Address2.errors?.maxlength,
               'text-muted': !f.Company_Address2.errors?.maxlength
             }">

                {{ icdForm.get('Company_Address2')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address2 }}

              </div>
              <div *ngIf="submitted && f.Company_Address2.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Address2.errors.required">Address 2  is required</div>
                <div *ngIf="f.Company_Address2.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Company_Address2 }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_City">City <code>*</code></label>
              <input type="text" formControlName="Company_City" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_City"
                     [ngClass]="{'is-valid': f.Company_City.valid, 'is-invalid' : submitted && !f.Company_City.valid}" placeholder="Enter  City"
                     appAiHint="Company City" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
               'text-danger': f.Company_City.errors?.maxlength,
               'text-muted': !f.Company_City.errors?.maxlength
             }">

                {{ icdForm.get('Company_City')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_City }}

              </div>
              <div *ngIf="submitted && f.Company_City.errors" class="invalid-feedback">
                <div *ngIf="f.Company_City.errors.required">City is required</div>
                <div *ngIf="f.Company_City.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Company_City }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Country">County <code>*</code></label>
              <input type="text" formControlName="Company_Country" class="form-control"
                     [ngClass]="{'is-valid': f.Company_Country.valid, 'is-invalid' : submitted && !f.Company_Country.valid}" placeholder="Enter County"
                     appAiHint="Company County" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Country.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Country.errors.required">County is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="Company_State">State <code>*</code></label>
              <ng-select [searchable]="true" formControlName="Company_State" [ngClass]="{'is-valid': f.Company_State.valid, 'is-invalid' : submitted && !f.Company_State.valid}">
                <ng-option *ngFor="let o of ddlUSStates"
                           [value]="o.value">
                  {{ o.name }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && f.Company_State.errors" class="invalid-feedback d-block">
                <div *ngIf="f.Company_State.errors.required">State is required</div>
              </div>

            </div>
          </div>


          <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="Company_Province">Province <code>*</code></label>
              <ng-select [searchable]="true" formControlName="Company_Province" [ngClass]="{'is-valid': f.Company_Province.valid, 'is-invalid' : submitted && !f.Company_Province.valid}">
                <ng-option *ngFor="let o of ddlCAProvinence"
                           [value]="o.value">
                  {{ o.name }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && f.Company_Province.errors" class="invalid-feedback d-block">
                <div *ngIf="f.Company_Province.errors.required">Province  is required</div>
              </div>

            </div>
          </div>



          <div class="col-sm-4">
            <div class="form-group">
              <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
              <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
              <input type="text" formControlName="Company_Postal_Code" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Postal_Code"
                     [ngClass]="{'is-valid': f.Company_Postal_Code.valid, 'is-invalid' : submitted && !f.Company_Postal_Code.valid}" placeholder="Enter  postal Code (Zip)"
                     appAiHint="Company Postal Code" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Company_Postal_Code.errors?.maxlength,
           'text-muted': !f.Company_Postal_Code.errors?.maxlength
         }">

                {{ icdForm.get('Company_Postal_Code')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Postal_Code }}

              </div>
              <div *ngIf="submitted && f.Company_Postal_Code.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Postal_Code.errors.required">Postal Code  is required</div>
                <div *ngIf="f.Company_Postal_Code.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Company_Postal_Code }} characters allowed
                </div>  
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Office_Phone">Office Phone <code>*</code></label>
              <input type="text" formControlName="Company_Office_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Company_Office_Phone"
                     [ngClass]="{'is-valid': f.Company_Office_Phone.valid, 'is-invalid' : submitted && !f.Company_Office_Phone.valid}"
                     placeholder="XXX-XXX-XXXX"
                     appAiHint="Company Office Phone" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Company_Office_Phone.errors?.maxlength,
           'text-muted': !f.Company_Office_Phone.errors?.maxlength
         }">

                {{ icdForm.get('Company_Office_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Office_Phone }}

              </div>
              <div *ngIf="submitted && f.Company_Office_Phone.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Office_Phone.errors.required">Office Phone  is required</div>
                <div *ngIf="f.Company_Office_Phone.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Company_Office_Phone }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Business_Email">Business Email <code>*</code></label>
              <input type="text" formControlName="Company_Business_Email" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Business_Email"
                     [ngClass]="{'is-valid': f.Company_Business_Email.valid, 'is-invalid' : submitted && !f.Company_Business_Email.valid}"
                     placeholder="Enter Business Email"
                     appAiHint="Company Business Email" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Company_Business_Email.errors?.maxlength,
           'text-muted': !f.Company_Business_Email.errors?.maxlength
         }">

                {{ icdForm.get('Company_Business_Email')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Business_Email }}

              </div>
              <div *ngIf="submitted && f.Company_Business_Email.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Business_Email.errors.required">Business Email  is required</div>
                <div *ngIf="f.Company_Business_Email.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Company_Business_Email }} characters allowed
                </div>  
              </div>

            </div>
          </div>

        </div>

        <!-- /.card-body -->
      </div>
    </div>


    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">Owner's Information</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_First_Name">Owner's Legal First Name <code>*</code></label>
              <input type="text" formControlName="Owner_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_First_Name"
                     [ngClass]="{'is-valid': f.Owner_First_Name.valid, 'is-invalid' : submitted && !f.Owner_First_Name.valid}"
                     placeholder="Enter  Owner Legal First Name"
                     appAiHint="Owner First Name" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_First_Name.errors?.maxlength,
           'text-muted': !f.Owner_First_Name.errors?.maxlength
         }">

                {{ icdForm.get('Owner_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_First_Name }}

              </div>
              <div *ngIf="submitted && f.Owner_First_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_First_Name.errors.required">Owner First Name is required</div>
                <div *ngIf="f.Owner_First_Name.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_First_Name }} characters allowed
                </div>  
              </div>

            </div>
          </div>
          <div class="col-sm-4">


            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Middle_Name">Owner's Legal Middle Name <code *ngIf="!noMiddleName">*</code></label>
              <div class="custom-control custom-switch custom-switch-on-success col-md-12 mb-2">
                <input type="checkbox" class="custom-control-input" id="noMiddleNameCheckbox" [checked]="noMiddleName" (change)="toggleMiddleName($event)" />
                <label class="custom-control-label" for="noMiddleNameCheckbox">No Middle Name</label>
              </div>
              <input type="text" formControlName="Owner_Middle_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Middle_Name"
                     [ngClass]="{'is-valid':  f.Owner_Middle_Name.valid, 'is-invalid' :submitted && !f.Owner_Middle_Name.valid}" placeholder="Enter Owner Legal Middle Name"
                     appAiHint="Owner Middle Name" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Middle_Name.errors?.maxlength,
           'text-muted': !f.Owner_Middle_Name.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Middle_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Middle_Name }}

              </div>
              <div *ngIf="submitted && f.Owner_Middle_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Middle_Name.errors.required">Middle Name is required</div>
                <div *ngIf="f.Owner_Middle_Name.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Middle_Name }} characters allowed
                </div>
              </div>
            </div>


          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Last_Name">Owner's Legal Last Name <code>*</code></label>
              <input type="text" formControlName="Owner_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Last_Name"
                     [ngClass]="{'is-valid': f.Owner_Last_Name.valid, 'is-invalid' : submitted && !f.Owner_Last_Name.valid}"
                     placeholder="Enter Owner Legal Last Name "
                     appAiHint="Owner Last Name" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Last_Name.errors?.maxlength,
           'text-muted': !f.Owner_Last_Name.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Last_Name }}

              </div>
              <div *ngIf="submitted && f.Owner_Last_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Last_Name.errors.required">Owner Last Name  is required</div>
                <div *ngIf="f.Owner_Last_Name.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Last_Name }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <!-- Feature 10 — secondary owner (read-only, shown when populated) -->
          <div class="col-sm-4" *ngIf="secondaryOwner">
            <div class="form-group">
              <label class="col-form-label col-md-12">Secondary Owner</label>
              <input type="text" class="form-control" [value]="secondaryOwner" disabled />
            </div>
          </div>

          <div class="row">

            <div class="col-sm-12 mb-3">
              <label class="col-form-label col-md-12" for="Is_Preferred_Differ_Yes">Is your preferred name different from your legal name? <code>*</code></label>
              <div class="col-md-12">
                <div class="form-check">
                  <input type="radio" value="Yes" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ_Yes" (change)="onIsPreferChange('Yes')" class="form-check-input" />
                  <label for="Is_Preferred_Differ_Yes" class="form-check-label">Yes</label>
                </div>
                <div class="form-check">
                  <input type="radio" value="No" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ_No" (change)="onIsPreferChange('No')" class="form-check-input" />
                  <label for="Is_Preferred_Differ_No" class="form-check-label">No</label>
                </div>
              </div>
            </div>

            <div class="col-sm-4" *ngIf="IsPref_Differ">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Owner_Preferred_First_Name">Preferred First Name <code>*</code></label>
                <input type="text" formControlName="Owner_Preferred_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Preferred_First_Name"
                       placeholder="Enter Preferred First Name"
                       appAiHint="Owner Preferred First Name" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
           'text-danger': f.Owner_Preferred_First_Name.errors?.maxlength,
           'text-muted': !f.Owner_Preferred_First_Name.errors?.maxlength
         }">

                  {{ icdForm.get('Owner_Preferred_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Preferred_First_Name }}

                </div>
                <div *ngIf="submitted && f.Owner_Preferred_First_Name.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Preferred_First_Name.errors.required">Preferred First Name is required</div>
                  <div *ngIf="f.Owner_Preferred_First_Name.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Preferred_First_Name }} characters allowed
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4" *ngIf="IsPref_Differ">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Owner_Preferred_Last_Name">Preferred Last Name <code>*</code></label>
                <input type="text" formControlName="Owner_Preferred_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Preferred_Last_Name"
                       placeholder="Enter Preferred Last Name"
                       appAiHint="Owner Preferred Last Name" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
           'text-danger': f.Owner_Preferred_Last_Name.errors?.maxlength,
           'text-muted': !f.Owner_Preferred_Last_Name.errors?.maxlength
         }">

                  {{ icdForm.get('Owner_Preferred_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Preferred_Last_Name }}

                </div>
                <div *ngIf="submitted && f.Owner_Preferred_Last_Name.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Preferred_Last_Name.errors.required">Preferred Last Name is required</div>
                  <div *ngIf="f.Owner_Preferred_Last_Name.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Preferred_Last_Name }} characters allowed
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">


              <div class="form-group">
                <label class="col-form-label col-md-12" for="login-Attach_Govt_Issued_ID">Upload a government issued photo ID (eg: Driver’s License or Passport) <code>*</code></label>
                <input type="file" formControlName="Attach_Govt_Issued_ID" (change)="onFileSelected($event, 'Attach_Govt_Issued_ID')" class="form-control"
                       [ngClass]="{'is-valid': f.Attach_Govt_Issued_ID.valid, 'is-invalid' : submitted && !f.Attach_Govt_Issued_ID.valid}"
                       [class.is-invalid]="isInvalid('Attach_Govt_Issued_ID')" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Govt_Issued_ID' }"></ng-container>
                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Govt_Issued_ID')">
                  <div *ngIf="icdForm.get('Attach_Govt_Issued_ID').errors.required">Driver's License is required</div>
                  <div *ngIf="icdForm.get('Attach_Govt_Issued_ID').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                  <div *ngIf="icdForm.get('Attach_Govt_Issued_ID').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png')</div>
                  <div *ngIf="icdForm.get('Attach_Govt_Issued_ID').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_Govt_Issued_ID']">
                  <span *ngIf="verificationState['Attach_Govt_Issued_ID'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_Govt_Issued_ID'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_Govt_Issued_ID'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_Govt_Issued_ID'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_Govt_Issued_ID']?.length > 0" class="mt-1 mb-0 pl-3 small text-warning" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_Govt_Issued_ID']">{{ issue }}</li>
                  </ul>
                </div>
                <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

              </div>

            </div>



          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label col-md-12" for="login-SSN-SIN">
                {{ isUS ? 'SSN' : 'SIN' }} <code>*</code>
              </label>
              <!-- Show masked value when not focused, and full value when editing -->
              <input type="text"
                     formControlName="SSN_SIN"
                     class="form-control"
                     [ngClass]="{'is-valid': f.SSN_SIN?.valid, 'is-invalid' : submitted && f.SSN_SIN?.invalid}"
                     placeholder="{{ isUS ? 'XXX-XX-XXXX' : 'XXX-XXX-XXX' }}"
                     (focus)="onFocus()"
                     (blur)="onBlur()"
                     [value]="displayValue"
                     (input)="onInputChange($event.target.value)"
                     appAiHint="SSN / SIN" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.SSN_SIN?.errors" class="invalid-feedback">
                <div *ngIf="f.SSN_SIN.errors.required">SSN/SIN is required</div>
                <div *ngIf="f.SSN_SIN.errors.pattern">Invalid {{ isUS ? 'SSN' : 'SIN' }} format</div>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label col-md-12" for="login-SSN-SIN">
                {{ isUS ? 'Confirm SSN' : 'Confirm SIN' }} <code>*</code>
              </label>
              <!-- Show masked value when not focused, and full value when editing -->
              <input type="text"
                     formControlName="SSN_SIN_C"
                     class="form-control"
                     [ngClass]="{'is-valid': f.SSN_SIN_C?.valid, 'is-invalid' : submitted && f.SSN_SIN_C?.invalid}"
                     placeholder="{{ isUS ? 'XXX-XX-XXXX' : 'XXX-XXX-XXX' }}"
                     (focus)="onFocus_C()"
                     (blur)="onBlur_C()"
                     [value]="displayValue_C"
                     (input)="onInputChange_C($event.target.value)"
                     appAiHint="Confirm SSN / SIN" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.SSN_SIN_C?.errors" class="invalid-feedback">
                <div *ngIf="f.SSN_SIN_C.errors.required">Confirm SSN/SIN is required</div>
                <div *ngIf="f.SSN_SIN_C.errors.pattern">Invalid {{ isUS ? 'SSN' : 'SIN' }} format</div>
                <div *ngIf="f.SSN_SIN_C.errors.mustMatch">SSN/SIN and   Confirm SSN/SIN  must match</div>
              </div>
            </div>
          </div>


          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Address1">Home Address 1 <code>*</code></label>
              <input type="text" formControlName="Owner_Address1" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Address1"
                     [ngClass]="{'is-valid': f.Owner_Address1.valid, 'is-invalid' : submitted && !f.Owner_Address1.valid}" placeholder="Enter  Home Address 1"
                     appAiHint="Owner Address 1" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Address1.errors?.maxlength,
           'text-muted': !f.Owner_Address1.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Address1')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Address1 }}

              </div>
              <div *ngIf="submitted && f.Owner_Address1.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Address1.errors.required">Home Address 1  is required</div>
                <div *ngIf="f.Owner_Address1.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Address1 }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Address2">Address 2 (e.g. Suite 100)</label>
              <input type="text" formControlName="Owner_Address2" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Address2"
                     placeholder="Enter Address 2 (e.g. Suite 100)"
                     appAiHint="Owner Address 2" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Address2.errors?.maxlength,
           'text-muted': !f.Owner_Address2.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Address2')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Address2 }}

              </div>
              <div *ngIf="submitted && f.Owner_Address2.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Address2.errors.required">Address 2 (e.g. Suite 100)  is required</div>
                <div *ngIf="f.Owner_Address2.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Address2 }} characters allowed
                </div>
              </div>

            </div>
          </div>



          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_City">City <code>*</code></label>
              <input type="text" formControlName="Owner_City" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_City"
                     [ngClass]="{'is-valid': f.Owner_City.valid, 'is-invalid' : submitted && !f.Owner_City.valid}" placeholder="Enter City"
                     appAiHint="Owner City" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_City.errors?.maxlength,
           'text-muted': !f.Owner_City.errors?.maxlength
         }">

                {{ icdForm.get('Owner_City')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_City }}

              </div>
              <div *ngIf="submitted && f.Owner_City.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_City.errors.required">City  is required</div>
                <div *ngIf="f.Owner_City.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_City }} characters allowed
                </div>
              </div>

            </div>
          </div>
          <div class="col-sm-4 hide" *ngIf="selectedCountry == 'US'">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Country">County <code>*</code></label>
              <input type="text" formControlName="Owner_Country" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Country.valid, 'is-invalid' : submitted && !f.Owner_Country.valid}" placeholder="Enter County"
                     />
              <div *ngIf="submitted && f.Owner_Country.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Country.errors.required">County is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="Owner_State">State <code>*</code></label>
              <ng-select [searchable]="true" formControlName="Owner_State" [ngClass]="{'is-valid': f.Owner_State.valid, 'is-invalid' : submitted && !f.Owner_State.valid}">
                <ng-option *ngFor="let o of ddlUSStates"
                           [value]="o.value">
                  {{ o.name }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && f.Owner_State.errors" class="invalid-feedback d-block">
                <div *ngIf="f.Owner_State.errors.required">State is required</div>
              </div>

            </div>
          </div>


          <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="Owner_Province">Province <code>*</code></label>
              <ng-select [searchable]="true" formControlName="Owner_Province" [ngClass]="{'is-valid': f.Owner_Province.valid, 'is-invalid' : submitted && !f.Owner_Province.valid}">
                <ng-option *ngFor="let o of ddlCAProvinence"
                           [value]="o.value">
                  {{ o.name }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && f.Owner_Province.errors" class="invalid-feedback d-block">
                <div *ngIf="f.Owner_Province.errors.required">Province  is required</div>
              </div>




            </div>
          </div>


          <div class="col-sm-4">
            <div class="form-group">
              <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
              <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
              <input type="text" formControlName="Owner_Postal_Code" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Postal_Code"
                     [ngClass]="{'is-valid': f.Owner_Postal_Code.valid, 'is-invalid' : submitted && !f.Tax_ID.valid}" placeholder="Enter  Postal Code (Zip)"
                     appAiHint="Owner Postal Code" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Postal_Code.errors?.maxlength,
           'text-muted': !f.Owner_Postal_Code.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Postal_Code')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Postal_Code }}

              </div>
              <div *ngIf="submitted && f.Owner_Postal_Code.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Postal_Code.errors.required">Postal Code (Zip)  is required</div>
                <div *ngIf="f.Owner_Postal_Code.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Postal_Code }} characters allowed
                </div>
              </div>

            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Mobile_Phone">Mobile Phone <code>*</code></label>
              <input type="text" formControlName="Owner_Mobile_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'elevenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Mobile_Phone"
                     placeholder="X-XXX-XXX-XXXX" [ngClass]="{'is-valid': f.Owner_Mobile_Phone.valid, 'is-invalid' : submitted && !f.Owner_Mobile_Phone.valid}"
                     appAiHint="Owner Mobile Phone" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Mobile_Phone.errors?.maxlength,
           'text-muted': !f.Owner_Mobile_Phone.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Mobile_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Mobile_Phone }}

              </div>
              <div *ngIf="submitted && f.Owner_Mobile_Phone.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Mobile_Phone.errors.required">Mobile Phone   is required</div>
                <div *ngIf="f.Owner_Mobile_Phone.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Mobile_Phone }} characters allowed
                </div>
                <div>Mobile phone must be 11 digits starting with 1 (country code).</div>
              </div>

            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Home_Phone">Home Phone</label>
              <input type="text" formControlName="Owner_Home_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Home_Phone"
                     placeholder="XXX-XXX-XXXX"
                     appAiHint="Owner Home Phone" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Home_Phone.errors?.maxlength,
           'text-muted': !f.Owner_Home_Phone.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Home_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Home_Phone }}

              </div>
              <div *ngIf="submitted && f.Owner_Home_Phone.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Home_Phone.errors.required">Home Phone  is required</div>
                <div *ngIf="f.Owner_Home_Phone.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Home_Phone }} characters allowed
                </div>
              </div>

            </div>
          </div>

          <div class="col-sm-4 hide">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Owner's Email <code>*</code></label>
              <input type="text" formControlName="Owner_Email" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Email"
                     [ngClass]="{'is-valid': f.Owner_Email.valid, 'is-invalid' : submitted && !f.Owner_Email.valid}" placeholder="Enter  Owner's Email"
                     appAiHint="Owner Email" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
           'text-danger': f.Owner_Email.errors?.maxlength,
           'text-muted': !f.Owner_Email.errors?.maxlength
         }">

                {{ icdForm.get('Owner_Email')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Email }}

              </div>
              <div *ngIf="submitted && f.Owner_Email.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Email.errors.required">Owner's Email is required</div>
                <div *ngIf="f.Owner_Email.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Email }} characters allowed
                </div>

              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label col-md-12" for="login-Owner_Perc">{{ secondaryOwner ? "Primary ICD's Ownership Percentage" : "Ownership Percentage" }} (Percent of the company you own. e.g... 100) <code>*</code></label>
              <input type="text"
                     (keypress)="preventNonInteger($event)"
                     formControlName="Owner_Perc"
                     class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Perc.valid,        'is-invalid': submitted && !f.Owner_Perc.valid  }"
                     placeholder="Enter Ownership Percentage"
                     appAiHint="Owner Percentage" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Perc.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Perc.errors.required">
                  Ownership Percentage is required
                </div>
                <div *ngIf="f.Owner_Perc.errors.min">
                  Ownership Percentage must be at least 1
                </div>
                <div *ngIf="f.Owner_Perc.errors.max">
                  Ownership Percentage cannot exceed 100
                </div>
                <div *ngIf="f.Owner_Perc.errors.integer">
                  Only whole numbers are allowed
                </div>
              </div>
            </div>
          </div>


          <div class="col-sm-12">

            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Perc">            Smart Circle and designated members of the Smart Circle Sales Network may need to contact you regarding the campaign in which your company participates. By providing your mobile phone number and checking the box below, you consent to receiving said text messages and phone calls that may use an automated system. Message frequency varies. Message and data rates may apply. Reply STOP to opt out of further messaging. Reply HELP for more information. Please see our Privacy Policy for more information. <code>*</code></label>
              <div class="col-sm-4">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" formControlName="Owner_Consent" class="custom-control-input" id="Owner_Consent">
                    <label class="custom-control-label" for="Owner_Consent">Yes</label>

                  </div>
                </div>
                <div *ngIf="!f.Owner_Consent" class="invalid-feedback">
                  <div *ngIf="!f.Owner_Consent">Consent  is required</div>
                </div>
                <span *ngIf="isConsentInvalid" style="color:red;">Consent  is required</span>
              </div>
            </div>
          </div>


        </div>
        <!-- /.card-body -->
      </div>
    </div>

    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">HUB Information</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">

            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name <code>*</code></label>
              <div class="col-md-12">
                <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                       class="form-control"
                       appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Number">Hub Number <code>*</code></label>
              <div class="col-md-12">
                <input type="text" formControlName="HUB_Manager_Contact_Number" id="login-HUB_Manager_Contact_Number" name="HUB_Manager_Contact_Number" placeholder="Enter Hub Number"
                       autocomplete="current-Owner_Last_Name" class="form-control"
                       appAiHint="HUB Manager Contact Number" [aiHintForm]="icdForm" />

              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">Hub Email <code>*</code></label>
              <div class="col-md-12">
                <input type="text" formControlName="HUB_Manager_Contact_Email" id="login-HUB_Manager_Contact_Email" name="HUB_Manager_Contact_Email" placeholder="Enter Hub Email" autocomplete="current-HUB_Manager_Contact_Email"
                       class="form-control"
                       appAiHint="HUB Manager Contact Email" [aiHintForm]="icdForm" />

              </div>
            </div>
          </div>

        </div>

        <!-- /.card-body -->
      </div>
    </div>

    <div class="card card-secondary">

      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <label class=" col-md-12" for="login-Owner_Perc" style="font-weight: lighter">
            At Smart Circle we believe that fostering a diverse sales network with people from different backgrounds and with different experiences creates equitable opportunities for small businesses. This also enhances our ability to innovate, understand diverse market perspectives, and ultimately deliver unparalleled solutions to meet the unique needs of our clients, retailers, and customers.

            In furtherance of our commitment and efforts to bring the most meaningful opportunities to ICDs and to assist us in responding to client inquiries regarding the diversity of our sales network.


          </label>
          <label class=" col-md-12" for="login-Owner_Perc">
            Please consider indicating below whether your company is at least 51% owned by individual(s) that identify as any of the following. <code>*</code>


          </label>

          <label class=" col-md-12" for="login-Owner_Perc" style="font-weight: lighter">

            Providing this information is voluntary and has no impact on your company’s status with Smart Circle.  Nor will this information (or whether or not you provide it) have any impact on your company’s prospects with Smart Circle, including consideration or eligibility for campaigns or contracts.  Information regarding the diversity of the sales network would only be disclosed to a third party such as a client or prospective client in the aggregate; for example, to demonstrate that Smart Circle contracts with a certain percentage of minority-owned businesses. (Select all that apply)
          </label>
          <div class="row">

            <div class="col-md-4" *ngFor="let demographic of demographicsData">
              <div class="form-group">
                <div class="custom-control custom-switch custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="demographic" [value]="demographic"
                         [disabled]="isCheckboxesDisabled" [checked]="selectedDemographics.includes(demographic)"
                         (change)="onCheckboxChange($event, demographic)">
                  <label class="custom-control-label" [for]="demographic">{{ demographic }}</label>
                </div>
              </div>
            </div>
            <span *ngIf="isDemographicsInvalid" style="color:red;">Please select at least one demographic</span>
          </div>

        </div>

        <!-- /.card-body -->
      </div>
    </div>
    <!-- AI Pre-Submit Review Modal -->
    <app-pre-submit-review
      [visible]="showPreSubmitReview"
      [issues]="preSubmitIssues"
      [loading]="preSubmitLoading"
      (dismiss)="onPreSubmitDismiss()"
      (submitAnyway)="onPreSubmitDoSubmit()"
      (recheck)="onPreSubmitRecheck()"
      (autoFix)="onPreSubmitAutoFix($event)"
      (navigateToField)="onPreSubmitNavigate($event)">
    </app-pre-submit-review>

    <div class="mb-3" *ngIf="btnDisplay">
      <button type="submit" class="btn btn-success float-right">
        {{isLoading ? 'Submit' : 'Submit'}}
      </button>
    </div>

  </form>

</div>

